"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestions = void 0;
var _useAddressSuggestionsQuery = require("./useAddressSuggestionsQuery");
const getSuggestions = async (api, minSearchLength, maxResults, searchText, country, pathKey) => {
  if (searchText.length >= minSearchLength) {
    const addressNodesResult = await (0, _useAddressSuggestionsQuery.fetchSuggestions)(api, {
      searchText,
      top: maxResults,
      country,
      pathKey
    });
    const {
      response
    } = addressNodesResult;
    if (response?.addressSuggestionsCollection) {
      const addressSuggestions = response.addressSuggestionsCollection.map(node => ({
        addressSummary: node.addressSummary,
        description: node.description,
        count: node.count,
        pathKey: node.pathKey,
        addressNodeId: node.addressNodeId
      }));
      return addressSuggestions;
    }
    return null;
  }
  return [];
};
exports.getSuggestions = getSuggestions;
//# sourceMappingURL=useAddressSuggestionSearchQuery.js.map